import React from 'react';
import { Link } from 'react-router-dom';
import { InfinityIcon, TruckIcon, LayersIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
const promises = [{
  icon: InfinityIcon,
  title: 'Lifetime replacement on multi-packs',
  body: 'Break it. We replace it. Optional on single X1 orders. Terms apply.',
  gold: true
}, {
  icon: LayersIcon,
  title: 'Full lens system',
  body: 'Clear, Amber and Smoke in every Complete System, or add them to your build.'
}, {
  icon: TruckIcon,
  title: 'Free U.S. shipping',
  body: 'Free standard shipping on every order.'
}, {
  icon: ShieldIcon,
  title: 'Built for real work',
  body: 'Made for people who use their hands.'
}];
const columns = [{
  title: 'Shop',
  links: [{
    label: 'Build your X1 from $29.95',
    href: '/#build-your-x1'
  }, {
    label: '1 X1 Complete System for $49.95',
    href: '/#offer'
  }, {
    label: 'Buy 2, get 1 free: $99.90',
    href: '/#offer'
  }, {
    label: 'Buy 4, get 2 free: $179.90',
    href: '/#offer'
  }, {
    label: 'Business / crew pack: $699.90',
    href: '/#company'
  }]
}, {
  title: 'Product',
  links: [{
    label: 'The 3-lens system',
    href: '/#lenses'
  }, {
    label: 'Product details',
    href: '/#details'
  }, {
    label: 'Specs & answers',
    href: '/#specs'
  }, {
    label: 'How it compares',
    href: '/#why'
  }]
}, {
  title: 'Support',
  links: [{
    label: 'Track my order',
    href: '/track'
  }, {
    label: 'How to use your X1',
    href: '/guide'
  }, {
    label: 'Lifetime replacement',
    href: '/#guarantee'
  }, {
    label: 'Shipping & returns',
    href: '/#shipping'
  }, {
    label: 'Reviews',
    href: '/#reviews'
  }, {
    label: 'FAQ',
    href: '/#faq'
  }, {
    label: 'Owner center',
    href: '/owner'
  }, {
    label: 'Activate your X1',
    href: '/activate'
  }, {
    label: 'Verify your GritVue',
    href: '/verify'
  }, {
    label: 'Crew Rewards',
    href: '/rewards'
  }, {
    label: 'Contact us',
    href: '/legal/contact'
  }]
}];
const legal = [{
  label: 'Privacy policy',
  to: '/legal/privacy'
}, {
  label: 'Terms of service',
  to: '/legal/terms'
}, {
  label: 'Returns & refunds',
  to: '/legal/returns'
}, {
  label: 'Shipping policy',
  to: '/legal/shipping'
}, {
  label: 'Warranty & protection terms',
  to: '/legal/guarantee'
}, {
  label: 'Legal notice & safety',
  to: '/legal/legal-notice'
}, {
  label: 'Contact us',
  to: '/legal/contact'
}];
export function SiteFooter() {
  return <footer id="support" className="scroll-mt-20 bg-ink-950" data-id="element-1311" data-mp="1ycadr6wdm6m3">
      <div className="border-y border-white/10 bg-ink-900" data-id="element-1312" data-mp="1tdz692tk0871">
        <ul className="mx-auto grid max-w-[1400px] gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1313" data-mp="1teidnplkve6t">
          {promises.map(promise => {
          const Icon = promise.icon;
          return <li key={promise.title} className={`flex items-start gap-3 px-5 py-6 lg:px-6 ${promise.gold ? 'bg-[#1a1408]' : 'bg-ink-900'}`} data-id="element-1314" data-mp="1kcspcsmzsvd9">
                <Icon className={`mt-0.5 h-6 w-6 shrink-0 ${promise.gold ? 'text-[#f2c94c]' : 'text-grit-500'}`} aria-hidden="true" data-id="element-1315" data-mp="3w0xfjyx9hui1" />
                <span data-id="element-1316" data-mp="4srzt67kpxv2">
                  <span className={`block font-display text-lg font-bold uppercase leading-tight tracking-wide ${promise.gold ? 'gold-text' : 'text-offwhite'}`} data-id="element-1317" data-mp="8vy5ocqrxn10">
                    {promise.title}
                  </span>
                  <span className="mt-1 block text-[13px] text-steel-400" data-id="element-1318" data-mp="3hbhqqohajz4z">{promise.body}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:px-8 lg:py-16" data-id="element-1319" data-mp="2pktvtu67npzr">
        <div data-id="element-1320" data-mp="2tlnjqnjnl4sn">
          <span className="block font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-offwhite" data-id="element-1321" data-mp="2tl48fpoidenl">
            Grit<span className="text-grit-500" data-id="element-1322" data-mp="2afppqhcbtw2s">Vue</span>
            <sup className="ml-1 align-super text-[11px] text-steel-500" data-id="element-1323" data-mp="25js7u6lf0hnw">™</sup>
          </span>
          <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.34em] text-steel-400" data-id="element-1324" data-mp="2k7vd1drmvpbn">
            See the job through
          </span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-steel-400" data-id="element-1325" data-mp="2ff2dd4b0v76f">
            GritVue X1 is illuminated work eyewear with built-in hands-free light and three interchangeable lenses.
            Designed for mechanics, builders, techs, drivers and anyone who works with their hands.
          </p>
          <div className="mt-6 border border-white/12 bg-ink-900 p-5" data-id="element-1326" data-mp="2y7ejm24sqslu">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-1327" data-mp="2y5bmyz952185">
              Support &amp; contact
            </h2>
            <p className="mt-2 text-sm text-steel-400" data-id="element-1328" data-mp="13u59q98c9532">
              Questions, order help or a lifetime replacement claim. A real person answers.
            </p>
            <a href="mailto:support@gritvuegear.com" className="mt-4 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1329" data-mp="3fj354c1x4lnv">
              <MailIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-1330" data-mp="3aofn8w1f6pi9" />
              support@gritvuegear.com
            </a>
            <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-steel-500" data-id="element-1331" data-mp="2wslov6y9vije">
              Monday to Friday · 8am to 6pm CT
            </p>
            <address className="mt-5 border-t border-white/10 pt-4 text-[13px] not-italic leading-relaxed text-steel-400" data-id="element-1332" data-mp="2mtcxmluski0q">
              <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-steel-500" data-id="element-1333" data-mp="2rrefj3ghebam">
                U.S. fulfillment network
              </span>
              GritVue Gear ships from U.S. warehouses in Fort Worth, TX, Tampa, FL and Los Angeles, CA.
            </address>
            <div className="mt-4" data-id="element-1334" data-mp="ok6zr0c49gnj">
              <UspsBadge data-id="element-1335" data-mp="jjj39z54c7lx" />
            </div>
          </div>
        </div>

        {columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-1336" data-mp="ek6db5iyakf4">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.12em] text-offwhite" data-id="element-1337" data-mp="ekoi4qjoi6yn">
              {column.title}
            </h2>
            <ul className="mt-5 grid gap-3" data-id="element-1338" data-mp="179n7o8q4sbdz">
              {column.links.map(link => <li key={link.label} data-id="element-1339" data-mp="129h8m7hj7mlv">
                  <Link to={link.href} className="text-sm text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1340" data-mp="12aiwxdnk65lj">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="border-t border-white/10" data-id="element-1341" data-mp="1l8v8f61xzrka">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-1342" data-mp="1l83b9qsp5lrw">
          <nav aria-label="Legal" data-id="element-1343" data-mp="1tjvgamdl1m9y">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-1344" data-mp="1xicicri5c6ki">
              {legal.map(item => <li key={item.label} data-id="element-1345" data-mp="22hxp3o3k5j7s">
                  <Link to={item.to} className="text-xs font-semibold uppercase tracking-wide text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-1346" data-mp="22gw3wqstvgcc">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-1347" data-mp="2l8f6iwixwsdu">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-steel-500" data-id="element-1348" data-mp="2la00ol1ce9b6">Secure checkout</p>
            <div className="mt-2" data-id="element-1349" data-mp="2q79zgramfxbo">
              <PaymentLogos data-id="element-1350" data-mp="2v6uyf1psk5oe" />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-1351" data-mp="2v51p1ensn7cp">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-1352" data-mp="3070tkrv9sab8">
          <p className="text-xs text-steel-500" data-id="element-1353" data-mp="3lj0ngsiv5n8o">© {new Date().getFullYear()} GritVue. All rights reserved.</p>
          <p className="max-w-xl text-xs leading-relaxed text-steel-500" data-id="element-1354" data-mp="3gk5u4wn9sgab">
            GritVue X1. Illuminated work glasses with built-in hands-free light and three interchangeable lenses.
          </p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-1355" data-mp="3pgojy007fo2o">Light where you look</p>
        </div>
      </div>
    </footer>;
}